// import React from "react";
// import { Utils } from '@svb${process.env.REACT_APP_CONTENT_SERVER}-component';
// import { slugCreator } from "../../../core/useStore";
/**
 * @todo: Please @dharma make sure to move all fetch into userstore fetch contents
 */
import { resolveRefs } from '../../resolver';
import { v4 as uuidv4 } from 'uuid';
import { regenTokenifExpired } from '../../utilityFunctions';

/**
 * SubMenuFromConfig
 * @todo: This component should load from content service
 * @param {object} item
 * @param {string} link
 * @param {integer} index
 * @returns
 */
function SubMenuFromConfig(item) {
  // Start checking the configs for each calatog from files
  // to get solutions catalog-data
  let path = `apis/${item.name}/${item.version}`;
  let filename = 'config.json';
  const token = localStorage.getItem('token');
  //   return SvbMenuContentFromConfig (path, filename);
  return fetch(
    `${process.env.REACT_APP_CONTENT_SERVER}/portal-content?resourcePath=${path}&resourceName=${filename}`,
    {
      headers: {
        Authorization: token,
        uuid: uuidv4(),
        audience: 'public',
      },
      credentials: 'omit',
    },
  ).then(async (x) => {
    // get config file
    return x.json();
  });
}
/**
 * SvbMenuContentFromConfig
 * @todo: This component should load from content service
 * @param {string} path
 * @param {string} filename
 * @returns
 */
function SvbMenuContentFromConfig(path, filename = '') {
  // Start checking the configs for each calatog from files
  // to get solutions catalog-data
  // let path = `apis/${item.name}/${item.version}`;
  const anontoken = regenTokenifExpired();
  // to remove / from filename as the content-svc resourceName only accepts the filename
  let filenameReplace = filename?.replace('/', '') || '';
  const responseFromConfig = anontoken.then((token) => {
    return fetch(
      `${process.env.REACT_APP_CONTENT_SERVER}/portal-content?resourcePath=${path}&resourceName=${filenameReplace}`,
      {
        headers: {
          Authorization: token,
          uuid: uuidv4(),
          audience: 'public',
        },
        credentials: 'omit',
      },
    )
      .then(async (x) => {
        if (!x?.ok) {
          let error = new Error(x?.statusText);
          error.ok = x?.ok;
          error.statusCode = x?.status || x?.code;
          throw error;
        }
        // get config file
        return x.text();
      })
      .catch((err) => {
        return err;
      });
  });
  return responseFromConfig;
}
/**
 * SvbMenuContentFromSpec
 * @todo: This component should load from content service
 * @param {string} path
 * @param {string} filename
 * @returns
 */
function SvbMenuContentFromSpec(path, filename) {
  // Start checking the configs for each calatog from files
  // to get solutions catalog-data
  // let path = `apis/${item.name}/${item.version}`;
  const token = localStorage.getItem('token');
  let filenameReplace = filename.replace('/', '');
  return fetch(
    `${process.env.REACT_APP_CONTENT_SERVER}/portal-content?resourcePath=${path}&resourceName=${filenameReplace}`,
    {
      headers: {
        Authorization: token,
        uuid: uuidv4(),
        audience: 'public',
      },
      credentials: 'omit',
    },
  )
    .then((x) => {
      // get config file
      return x.json();
    })
    .then((data) => {
      //Deep recursive merge done using Map to avoid prototype pollution from source before using data for other logics
      const sanitizedSafeMappedData = deepMergeMap(new Map(), data);
      // const sanitizedWithoutMappedData = deepMerge(null, data);
      const safeObject = mapToObjectRecursive(sanitizedSafeMappedData); //convert Map data to Object
      const safeNullProtoObj = Object.assign(Object.create(null), safeObject);
      return safeNullProtoObj?.components ? resolveRefs(safeNullProtoObj) : safeNullProtoObj;
    })
    .catch((err) => {
      return err;
    });
}
function isSafeKey(key) {
  return key !== '__proto__' && key !== 'constructor' && key !== 'prototype';
}

// Deep Merge using Map to avoid prototype pollution inheritance
function deepMergeMap(target, source) {
  if (!(target instanceof Map)) target = new Map();

  for (const key of Object.keys(source)) {
    if (!isSafeKey(key)) continue; //skip dangerous keys
    const value = source[key];
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      target.set(key, deepMergeMap(target.get(key) || new Map(), value));
    } else {
      target.set(key, value);
    }
  }
  return target;
}

//converts Map to Object with recursion
const mapToObjectRecursive = (map) => {
  if (!(map instanceof Map)) {
    // If it's not a Map, return it as is (base case for recursion)
    return map;
  }

  const obj = {};
  for (let [key, value] of map.entries()) {
    if (value instanceof Map) {
      // If the value is another Map, recursively convert it
      obj[key] = mapToObjectRecursive(value);
    } else if (Array.isArray(value)) {
      // Handle arrays, potentially containing nested Maps
      obj[key] = value.map((item) => mapToObjectRecursive(item));
    } else {
      // For other types, assign directly
      obj[key] = value;
    }
  }
  return obj;
};
//checks if key is of object or not
// function isObject(key) {
//   return key !== null && typeof key === 'object' && !Array.isArray(key);
// }

// used for merging data to avoid prototype pollution without using map
// function deepMerge(target, source) {
//   if (!isObject(target)) {
//     target = createSafeObj();
//   }

//   if (!isObject(source)) {
//     return source;
//   }
//   for (const key in source) {
//     if (!isSafeKey(key)) continue;

//     const sourceVal = source[key];
//     const targetVal = target[key];
//     if (Array.isArray(sourceVal)) {
//       target[key] = sourceVal.slice();
//     } else if (isObject(sourceVal)) {
//       target[key] = deepMerge(targetVal, sourceVal);
//     } else {
//       target[key] = sourceVal;
//     }
//   }
//   return target;
// }
//used to create safe Object incase prototype is removed from object and our application logic needs these properties
// function createSafeObj() {
//   const obj = Object.create(null);
//   Object.defineProperty(obj, 'hasOwnProperty', {
//     value: Object.prototype.hasOwnProperty,
//     writable: false,
//     configurable: false,
//     enumerable: false,
//   });

//   Object.defineProperty(obj, Symbol.toPrimitive, {
//     value: function (hint) {
//       if (hint === 'string') {
//         return '[SafeObject]';
//       }
//       if (hint === 'number') {
//         return NaN;
//       }
//       return '[safeObject]';
//     },
//     writable: false,
//     configurable: false,
//     enumerable: false,
//   });

//   Object.defineProperty(obj, 'toString', {
//     value: function () {
//       return '[safeObject]';
//     },
//     writable: false,
//     configurable: false,
//     enumerable: false,
//   });

//   return obj;
// }

// function sanitizePrototype(data) {
//   //return as it is for primitive type (number, string, boolean, undefined or null)
//   if (typeof data !== 'object' || data === null) return data;
//   //if array, recursively sanitize each element with map and return a new array with sanitized elements
//   if (Array.isArray(data)) {
//     return data.map(sanitizePrototype);
//   }

//   const safeObj = Object.create(null); //create a safe object with no prototype
//   //dangerous property keys to be sanitized from data object, additional checks
//   const keysToBeSkipped = new Set(['__proto__', 'constructor', 'prototype']);
//   for (const key of Object.keys(data)) {
//     if (!keysToBeSkipped.has(key)) {
//       safeObj[key] = sanitizePrototype(data[key]);
//     }
//   }
//   //make object react friendly
//   // const safePlainObj = {};
//   // for (const key of safeObj) {
//   //   if (Object.prototype.hasOwnProperty.call(safeObj, key)) {
//   //     safePlainObj[key] = safeObj[key];
//   //   }
//   // }

//   // return safePlainObj;
//   return Object.fromEntries(Object.entries(safeObj));
// }
export { SubMenuFromConfig, SvbMenuContentFromConfig, SvbMenuContentFromSpec };
